const ErrorDetailComponent = ({ errors }) => {
    if (!Array.isArray(errors)) {
        console.log(errors)
        console.error("ErrorDetail received something other than an arrray")
    }
    if (errors.length == 0) {
        console.log("Errors array is empty")
    }
    let elements = []
    for (let i = 0; i < errors.length; i++) {
        const error = errors[i].toString()
        elements.push(<div>{error}</div>)
    }
    return (<div className="alert alert-danger">{elements}</div>)
}
export default ErrorDetailComponent